import { useContext } from 'react'

import { OrderDraftItemBackgroundUpdateStatusContext } from './OrderDraftItemBackgroundUpdateStatusContext'

export const useOrderDraftItemBackgroundUpdateStatusContext = () => {
  const context = useContext(OrderDraftItemBackgroundUpdateStatusContext)

  if (!context) {
    throw new Error(
      'useOrderDraftItemBackgroundUpdateStatusContext must be used within an OrderDraftItemBackgroundUpdateStatusContextProvider'
    )
  }

  return context
}
